// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"750da4f7","183":"3a68870f","233":"9738cfb4","453":"437cf289","469":"2f340fcf","906":"3659b171","997":"2958f6ce"}[chunkId] + ".chunk.js";
};